(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["template-cart"]) return;
  try {
    
  $(document).on('click','#refuse-upsell', function (event) {
    $('#cart-upsell'). fadeOut(200);
  });

  $(document).on('click','#upsell-add-to-cart', function (event) {
    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {quantity: 1, id:  $('#upsell-variant-id').val()},
      complete: function( data ) {
        location.reload();
        $('#cart-upsell'). fadeOut(200);
      }
    });
  });  

  $('#cart-form').ready(function(event) {
    performVATBind();
  });

  } catch(e) { console.error(e); }
})();

})();
